import React from 'react';
import VoteFrontDeskList from './components/VoteFrontDeskList';

const VoteFrontDesk = () => (
  <VoteFrontDeskList />
);

export default VoteFrontDesk;
